import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'

import useBreakToggle from './useBreakToggle'
import { BreakTimer, ToggleWrap } from './styled-components'

const BreakToggle = () => {
  const { isOnBreak, buttonOverrides, label, timer, isDisabled, toggle } = useBreakToggle()

  return (
    <ToggleWrap>
      {/* @ts-expect-error SDButton is a JS component */}
      <SDButton
        id='break-toggle-btn'
        block
        disabled={isDisabled}
        onClick={toggle}
        overrides={buttonOverrides}
      >
        {label}
      </SDButton>
      <BreakTimer hidden={!isOnBreak}>{timer}</BreakTimer>
    </ToggleWrap>
  )
}

export default BreakToggle
